export const STORAGE_KEY = 'bhp-optimiser-status-sections';

// All localStorage access for the collapsible-section map is isolated here so the
// component stays testable and a disabled or failing localStorage degrades
// gracefully to session-only collapse state.
export const readSections = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  }
  catch (e) {
    return {};
  }
};

export const writeSections = (map) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  }
  catch (e) {
    // localStorage unavailable/full — collapse state lives for the session only.
  }
};
